<template>
	<div class="pop-box" :hidden="hidden">
		<div class="box-top">
			<p>{{PaymentName}}</p>
			<div class="hide-box" @click="hideBox"><img src="../../assets/imgs/hide.png" alt=""></div>
		</div>
		<div class="box-area" v-show="type=='Web-ATM'">
			<!--银行选择区域-->
			<div class="box-select">
				<div class="select-area">
					<div class="select-title">選擇銀行：</div>
					<div class="store-area">
						<div class="store-left">{{curStore}}</div>
						<div class="store-right" @click="showStore">
							<img :class="{'right-img':storeHidden,'right-img-select':!storeHidden}" src="../../assets/imgs/pay-select.png" alt="">
						</div>
						<div class="store-select" :hidden="storeHidden">
							<div v-bind:key="item.value" :class="{'store-item':true,'store-can-select':item.status}" v-for="(item,index) in bankArr"  @click="selectStore(item,index)" >{{item.name}}</div>
						</div>
					</div>
				</div>
			</div>
			<!--支付选择区域-->
			<div class="coin-select">
				<div class="coin-title">储值金额：</div>
				<div class="pay-area">
					<div :class="{'pay-item':true,'item-select':(curItem==0?true:false)}" @click="setAmount(150,0)">
						<p class="area-one">150TWD</p>
						<p class="area-two">3000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}150=3150{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">9.5{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==1?true:false)}" @click="setAmount(300,1)">
						<p class="area-one">300TWD</p>
						<p class="area-two">6000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}600=6600{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">9{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==2?true:false)}" @click="setAmount(750,2)">
						<p class="area-one">750TWD</p>
						<p class="area-two">15000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}3000=18000{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">8{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==3?true:false)}" @click="setAmount(1500,3)">
						<p class="area-one">1500TWD</p>
						<p class="area-two">30000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}12000=42000{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">6{{$t("discount")}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="box-area" v-show="type=='F7'">
			<div class="coin-select">
				<div class="coin-title">储值金额：</div>
				<div class="pay-area">
					<div :class="{'pay-item':true,'item-select':(curItem==0?true:false)}" @click="setPay('F7','SPS0456034',300,0);">
						<p class="area-one">300TWD</p>
						<p class="area-two">6000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}600=6600{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">9{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==1?true:false)}" @click="setPay('F7','SPS0456052',500,1)">
						<p class="area-one">500TWD</p>
						<p class="area-two">9600{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}1920=11520{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">8{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==2?true:false)}" @click="setPay('F7','SPS0456056',1000,2)">
						<p class="area-one">1000TWD</p>
						<p class="area-two">19200{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}5760=24960{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">7{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==3?true:false)}" @click="setPay('F7','SPS0456063',2000,3)">
						<p class="area-one">2000TWD</p>
						<p class="area-two">38400{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}15360=53760{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">6{{$t("discount")}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="box-area" v-show="type=='F1'">
			<div class="coin-select">
				<div class="coin-title">储值金额：</div>
				<div class="pay-area">
					<div :class="{'pay-item':true,'item-select':(curItem==0?true:false)}" @click="setPay('F1','SPS0456033',300,0);">
						<p class="area-one">300TWD</p>
						<p class="area-two">6000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}600=6600{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">9{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==1?true:false)}" @click="setPay('F1','SPS0456051',500,1)">
						<p class="area-one">500TWD</p>
						<p class="area-two">9600{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}1920=11520{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">8{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==2?true:false)}" @click="setPay('F1','SPS0456055',1000,2)">
						<p class="area-one">1000TWD</p>
						<p class="area-two">19200{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}5760=24960{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">7{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==3?true:false)}" @click="setPay('F1','SPS0456062',2000,3)">
						<p class="area-one">2000TWD</p>
						<p class="area-two">38400{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}15360=53760{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">6{{$t("discount")}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="box-area" v-show="type=='F2'">
			<div class="coin-select">
				<div class="coin-title">储值金额：</div>
				<div class="pay-area">
					<div :class="{'pay-item':true,'item-select':(curItem==0?true:false)}" @click="setPay('F2','SPS0456036',300,0);">
						<p class="area-one">300TWD</p>
						<p class="area-two">6000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}600=6600{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">9{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==1?true:false)}" @click="setPay('F2','SPS0456054',500,1)">
						<p class="area-one">500TWD</p>
						<p class="area-two">9600{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}1920=11520{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">8{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==2?true:false)}" @click="setPay('F2','SPS0456058',1000,2)">
						<p class="area-one">1000TWD</p>
						<p class="area-two">19200{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}5760=24960{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">7{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==3?true:false)}" @click="setPay('F2','SPS0456064',2000,3)">
						<p class="area-one">2000TWD</p>
						<p class="area-two">38400{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}15360=53760{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">6{{$t("discount")}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="box-area" v-show="type=='INGAME'">
			<div class="coin-select">
				<div class="coin-title">储值金额：</div>
				<div class="pay-area">
					<div :class="{'pay-item':true,'item-select':(curItem==0?true:false)}" @click="setPay('INGAME','INOVMI150',150,0)">
						<p class="area-one">150TWD</p>
						<p class="area-two">3000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}150=3150{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">9.5{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==1?true:false)}" @click="setPay('INGAME','INOVMI300',300,1)">
						<p class="area-one">300TWD</p>
						<p class="area-two">6000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}600=6600{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">9{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==2?true:false)}" @click="setPay('INGAME','INOVMI750',750,2)">
						<p class="area-one">750TWD</p>
						<p class="area-two">15000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}3000=18000{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">8{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==3?true:false)}" @click="setPay('INGAME','INOVMI1490',1490,3)">
						<p class="area-one">1490TWD</p>
						<p class="area-two">30000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}12000=42000{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">6{{$t("discount")}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="box-area" v-show="type=='HC0004'">
			<div class="coin-select">
				<div class="coin-title">储值金额：</div>
				<div class="pay-area">
					<div :class="{'pay-item':true,'item-select':(curItem==0?true:false)}" @click="setPay('HC0004','SPS0455987',150,0)">
						<p class="area-one">150TWD</p>
						<p class="area-two">3000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}150=3150{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">9.5{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==1?true:false)}" @click="setPay('HC0004','SPS0455987',300,1)">
						<p class="area-one">300TWD</p>
						<p class="area-two">6000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}600=6600{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">9{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==2?true:false)}" @click="setPay('HC0004','SPS0455987',750,2)">
						<p class="area-one">750TWD</p>
						<p class="area-two">15000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}3000=18000{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">8{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==3?true:false)}" @click="setPay('HC0004','SPS0455987',1500,3)">
						<p class="area-one">1500TWD</p>
						<p class="area-two">30000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}12000=42000{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">6{{$t("discount")}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="box-area" v-show="type=='HC0035'">
			<div class="coin-select">
				<div class="coin-title">储值金额：</div>
				<div class="pay-area">
					<div :class="{'pay-item':true,'item-select':(curItem==0?true:false)}" @click="setPay('HC0035','SPS0456018',150,0)">
						<p class="area-one">150TWD</p>
						<p class="area-two">3000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}150=3150{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">9.5{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==1?true:false)}" @click="setPay('HC0035','SPS0456018',300,1)">
						<p class="area-one">300TWD</p>
						<p class="area-two">6000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}600=6600{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">9{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==2?true:false)}" @click="setPay('HC0035','SPS0456018',750,2)">
						<p class="area-one">750TWD</p>
						<p class="area-two">15000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}3000=18000{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">8{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==3?true:false)}" @click="setPay('HC0035','SPS0456018',1500,3)">
						<p class="area-one">1500TWD</p>
						<p class="area-two">30000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}12000=42000{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">6{{$t("discount")}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="box-area" v-show="type=='FA038'">
			<div class="coin-select">
				<div class="coin-title">储值金额：</div>
				<div class="pay-area">
					<div :class="{'pay-item':true,'item-select':(curItem==0?true:false)}" @click="setPay('FA038','SPS0455984',150,0)">
						<p class="area-one">150TWD</p>
						<p class="area-two">3000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}150=3150{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">9.5{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==1?true:false)}" @click="setPay('FA038','SPS0455984',300,1)">
						<p class="area-one">300TWD</p>
						<p class="area-two">6000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}600=6600{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">9{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==2?true:false)}" @click="setPay('FA038','SPS0455984',750,2)">
						<p class="area-one">750TWD</p>
						<p class="area-two">15000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}3000=18000{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">8{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==3?true:false)}" @click="setPay('FA038','SPS0455984',1500,3)">
						<p class="area-one">1500TWD</p>
						<p class="area-two">30000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}12000=42000{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">6{{$t("discount")}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="box-area" v-show="type=='phone'">
			<!--银行选择区域-->
			<div class="box-select">
				<div class="select-area">
					<div class="select-title">選擇電話廠商區：</div>
					<div class="store-area">
						<div class="store-left">{{curStore}}</div>
						<div class="store-right" @click="showStore">
							<img :class="{'right-img':storeHidden,'right-img-select':!storeHidden}" src="../../assets/imgs/pay-select.png" alt="">
						</div>
						<div class="store-select" :hidden="storeHidden">
							<div v-bind:key="item.value" :class="{'store-item':true,'store-can-select':item.status}" v-for="(item,index) in phoneArr"  @click="selectStore(item,index)" >{{item.name}}</div>
						</div>
					</div>
				</div>
			</div>
			<!--支付选择区域-->
			<div class="coin-select">
				<div class="coin-title">储值金额：</div>
				<div class="pay-area">
					<div :class="{'pay-item':true,'item-select':(curItem==0?true:false)}" @click="setAmount(150,0)">
						<p class="area-one">150TWD</p>
						<p class="area-two">3000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}150=3150{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">9.5{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==1?true:false)}" @click="setAmount(300,1)">
						<p class="area-one">300TWD</p>
						<p class="area-two">6000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}600=6600{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">9{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==2?true:false)}" @click="setAmount(750,2)">
						<p class="area-one">750TWD</p>
						<p class="area-two">15000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}3000=18000{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">8{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==3?true:false)}" @click="setAmount(1500,3)">
						<p class="area-one">1500TWD</p>
						<p class="area-two">30000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}12000=42000{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">6{{$t("discount")}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="box-area" v-show="type=='COSTPOINT'">
			<div class="coin-select">
				<div class="coin-title">储值金额：</div>
				<div class="pay-area">
					<div :class="{'pay-item':true,'item-select':(curItem==0?true:false)}" @click="setPay('COSTPOINT','MFSD002641',150,0)">
						<p class="area-one">150TWD</p>
						<p class="area-two">3000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}150=3150{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">9.5{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==1?true:false)}" @click="setPay('COSTPOINT','MFSD002641',300,1)">
						<p class="area-one">300TWD</p>
						<p class="area-two">6000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}600=6600{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">9{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==2?true:false)}" @click="setPay('COSTPOINT','MFSD002641',750,2)">
						<p class="area-one">750TWD</p>
						<p class="area-two">15000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}3000=18000{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">8{{$t("discount")}}</p>
						</div>
					</div>
					<div :class="{'pay-item':true,'item-select':(curItem==3?true:false)}" @click="setPay('COSTPOINT','MFSD002641',1500,3)">
						<p class="area-one">1500TWD</p>
						<p class="area-two">30000{{$t("coin")}}</p>
						<p class="area-three">{{$t("giftCoin")}}12000=42000{{$t("coin")}}</p>
						<div class="dis-count">
							<img src="../../assets/imgs/zhekou.png" alt="">
							<p class="dis-num">6{{$t("discount")}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="btn-area">
			<div class="pay-btn" @click="gopay">去支付</div>
		</div>
	</div>
</template>
<script>
export default {
  name: "mycardpayitem",
  props: ["type", "hidden", "onHide", "PaymentName"],
  data() {
    return {
      boxShow: false,
      book_id: this.$route.query.id ? this.$route.query.id : 0,
      amount: 0,
      curItem: 1,
      ItemCode: "",
      PaymentType: "",
      storeHidden: true,
      curStore: "",

      // 银行选项
      bankArr: [
        { value: "SPS0456012", type: "HA0008", name: "玉山银行", status: true },
        {
          value: "SPS0456003",
          type: "HF0001",
          name: "中華郵政",
          status: false
        },
        {
          value: "SPS0456001",
          type: "HA0006",
          name: "華南銀行",
          status: false
        },
        {
          value: "SPS0455997",
          type: "HA0001",
          name: "國泰世華",
          status: false
        },
        { value: "SPS0456010", type: "99", name: "合作金庫", status: false },
        {
          value: "SPS0456002",
          type: "HA0014",
          name: "土地銀行",
          status: false
        },
        {
          value: "SPS0456000",
          type: "HA0019",
          name: "第一銀行",
          status: false
        },
        {
          value: "SPS0456006",
          type: "HA0010",
          name: "台新銀行",
          status: false
        },
        {
          value: "SPS0455999",
          type: "HA0007",
          name: "中國信託",
          status: false
        },
        { value: "SPS0455998", type: "FA035", name: "彰化銀行", status: false },
        {
          value: "SPS0456005",
          type: "HA0015",
          name: "新光銀行",
          status: false
        },
        {
          value: "SPS0456004",
          type: "HA0016",
          name: "上海銀行",
          status: false
        },
        {
          value: "SPS0456008",
          type: "HA0013",
          name: "台北富邦",
          status: false
        },
        { value: "SPS0456009", type: "FA036", name: "兆豐銀行", status: false },
        {
          value: "SPS0456007",
          type: "HA0017",
          name: "台灣銀行",
          status: false
        },
        { value: "SPS0456011", type: "HA0018", name: "日盛銀行", status: false }
      ],
      // 手机厂商
      phoneArr: [
        { value: "SPS0455990", type: "HE0037", name: "遠傳電信", status: true },
        {
          value: "SPS0455988",
          type: "HE0001",
          name: "台灣大哥大電信",
          status: false
        },
        {
          value: "SPS0455995",
          type: "FS0018",
          name: "亞太電信",
          status: false
        },
        {
          value: "SPS0455994",
          type: "HE0021",
          name: "台灣之星",
          status: false
        },
        {
          value: "SPS0455992",
          type: "HE0004",
          name: "中華電信839",
          status: false
        },
        {
          value: "SPS0455993",
          type: "HE0011",
          name: "中華電信市內電話",
          status: false
        },
        {
          value: "SPS0455991",
          type: "HE0003",
          name: "中華電信HiNet",
          status: false
        }
      ]
    };
  },
  mounted() {},

  updated() {
    //默认设置
    if (this.PaymentType == "") {
      switch (this.type) {
        case "Web-ATM":
          this.PaymentType = "HA0008";
          this.curStore = "玉山银行";
					this.ItemCode = "SPS0456012";
					this.amount = 300;
          break;
        case "phone":
					this.amount = 300;
          this.PaymentType = "HE0037";
          this.curStore = "遠傳電信";
          this.ItemCode = "SPS0455990";
          break;
        case "F7":
          this.setPay('F7','SPS0456052',500,1)
          break;
        case "F1":
          this.setPay('F1','SPS0456051',500,1)
          break;
        case "F2":
          this.setPay('F2','SPS0456054',500,1)
          break;
        case "INGAME":
          this.setPay('INGAME','INOVMI300',300,1)
          break;
        case "HC0004":
          this.setPay('HC0004','SPS0455987',300,1)
          break;
        case "HC0035":
          this.setPay('HC0035','SPS0456018',300,1)
          break;
        case "FA038":
          this.setPay('FA038','SPS0455984',300,1)
          break;
        case "COSTPOINT":
          this.setPay('COSTPOINT','MFSD002641',300,1)
          break;
      }
    }
  },
  methods: {
    hideBox() {
			this.PaymentType="";
      this.boxShow = false;
      if (this.onHide) {
        this.onHide();
      }
    },
    setPay(type, item, amount, i) {
      this.PaymentType = type;
      this.ItemCode = item;
      this.setAmount(amount, i);
    },
    setAmount(amount, i) {
      this.curItem = i;
      this.amount = amount;
    },
    showStore() {
      this.storeHidden = false;
    },
    selectStore(item, index) {
      this.setPay(item.type, item.value);
      this.curStore = item.name;
      this.storeHidden = true;
    },
    gopay() {
      this.req
        .mycard(this.PaymentType, this.ItemCode, this.amount, this.book_id)
        .then(res => {
          if (res.url) {
            window.location.href = res.url;
          }else{
						that.$toast({
                message: res.result,
                duration: 3000
              });
					}
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/common/mycardpayitem.vue